import React from 'react';
import { observer } from 'mobx-react';
import { Col, Grid, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { truncate } from '../../utils/stringUtils';

@observer
export default class TrendsPostGrid extends React.Component {
    render() {
        const posts = this.props.store.gridFeatures;

        return (
            <Col xs={12} componentClass="section" className="posts-grid">
                <Grid>
                    <Row>
                        {posts.length
                            ? posts.map((post, i) => {
                                  let linkHref = `/trend/${
                                      post.blogPostUrlPath
                                  }`;

                                  return (
                                      <Col
                                          key={i}
                                          xs={12}
                                          sm={4}
                                          className="post-category"
                                      >
                                          <Link to={linkHref}>
                                              <div
                                                  className="img-container"
                                                  style={{
                                                      background: `url(${
                                                          post.imageUrl
                                                      }) center center / cover no-repeat`
                                                  }}
                                              />
                                          </Link>
                                          <div className="text-container">
                                              <Link
                                                  to={linkHref}
                                                  className="post-link"
                                              >
                                                  <h2>{post.title}</h2>
                                              </Link>
                                              <p>
                                                  {truncate(post.summary, 135)}
                                              </p>
                                              <Link
                                                  to={linkHref}
                                                  className="underline-link dark"
                                              >
                                                  Read more
                                              </Link>
                                          </div>
                                      </Col>
                                  );
                              })
                            : null}
                    </Row>
                </Grid>
            </Col>
        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/trends/TrendsPostGrid.jsx